/**
 * What to call a dialog in the telemetry.
 *
 * Every dialog in the portal is an RcDialog, so it is named there once rather
 * than in each of the hundred-odd components that render one. The name comes
 * from the component doing the rendering, never from the dialog's `title`: a
 * title reads "Remove User: Jane Smith" or "Run Report: Night Shift", and a
 * driver's name is not something to send anywhere.
 *
 * The SFC compiler fills in `__name` from the file name. It is stable, it says
 * nothing about anybody, and it survives minification - the production bundle
 * carries every one of them.
 *
 * This lives beside pageName.js rather than inside RcDialog so it can be tested
 * without a component harness, which this project does not have.
 */
const nameOf = (type) => {
  return (type && (type.__name || type.name)) || 'unknown';
};

/** The name of the component that rendered this one. Used by RcDialog. */
export const dialogNameOf = (instance) => {
  return nameOf(instance ? (instance.parent ? instance.parent.type : null) : null);
};

/** A component's own name. Used by a dialog reporting its own outcome. */
export const ownNameOf = (instance) => {
  return nameOf(instance ? instance.type : null);
};

export default dialogNameOf;
